module.exports = __webpack_public_path__ + "static/media/focco.a0ba561a.png";